import { render, staticRenderFns } from "./BusinessViewModal.vue?vue&type=template&id=4104be87"
import script from "./BusinessViewModal.vue?vue&type=script&lang=js"
export * from "./BusinessViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports